import type { RenderMode, SSRContext } from '@seamless/oneweb-ssr';
import type { PartialAemEnvState, Environment, AemData } from '../types/types';

/**
 * Map the AEM environment and component data to a single object.
 */
export function mapEnvToAemData<ComponentData>(
  url: string,
  aemEnv: PartialAemEnvState,
  componentData: ComponentData,
  isAemEditMode: boolean = false,
  renderMode: RenderMode = 'csr',
): AemData<ComponentData> {
  const { country, language, vehicleData, stage, title } = aemEnv;

  return {
    url,
    isAemEditMode,
    renderMode,
    country: mapAntarcticaMarket(country, language),
    language,
    title,
    modelSeries: vehicleData.modelSeries,
    stage: stage as Environment,
    ...componentData,
  };
}

export function mapSSRContextToAemData<ComponentData>(
  context: SSRContext<ComponentData>,
  isSSR: boolean,
): AemData<ComponentData> {
  const { runMode, wcmMode } = context.pageAEMContext;

  return mapEnvToAemData(
    context.requestUrl,
    context.pageAEMContext as any,
    context.payload,
    !isSSR && runMode == 'AUTHOR' && wcmMode == 'EDIT',
    isSSR ? 'ssr' : 'csr',
  );
}

/**
 * * Map the Antartica market since it is not supported by the API
 * ! Test purposes only
 */
export const mapAntarcticaMarket = (country: string, language: string) => {
  if (country === 'AQ') return aqLanguageMap[language] ?? country;
  return country;
};

const aqLanguageMap: Record<string, string> = {
  de: 'DE',
};
